const manualUploads = {
  en: {
    manualUploads: {
      // Header/Navigation
      header: {
        title: 'Online Bulk Upload',
        nav: {
          upload: 'Upload online articles',
          uploadOnline: 'Upload online articles',
          uploadPrint: 'Upload print articles',
          manage: 'Manage'
        }
      },

      // Print Ingest (print-specific strings)
      print: {
        header: {
          title: 'Print Bulk Upload'
        },
        template: {
          download: 'Download ZIP template'
        },
        upload: {
          selectFile: 'Select the ZIP file',
          supportedFormat: 'Supported format: .zip'
        },
        messages: {
          invalidFileFormat: 'Please select a valid ZIP file (.zip)'
        },
        columns: {
          outlet: 'Outlet',
          datePublished: 'Date Published',
          coverage: 'Coverage',
          frontPage: 'Front Page',
          headline: 'Headline',
          fullText: 'Full Text',
          assets: 'Assets',
          assetsImages: 'Image assets',
          assetsPdfs: 'PDF assets',
          keywords: 'Keywords',
          status: 'Status'
        },
        form: {
          pageNumber: 'Page Number',
          coverage: 'Coverage',
          frontPage: 'Front Page',
          position: 'Position',
          toggleFullPage: 'Toggle full Page',
          clearPage: 'Clear Page'
        }
      },

      // Project Selection
      project: {
        label: 'Project',
        required: '*',
        placeholder: 'Search for a project...',
        noResults: 'No projects found',
        noOptions: 'Start typing to search projects...',
        clearSelection: 'Clear project selection'
      },

      // Template Download
      template: {
        download: 'Download Excel template'
      },

      // File Upload
      upload: {
        selectFile: 'Select the Excel file',
        clickToBrowse: 'Click to browse or drag and drop your file here',
        supportedFormat: 'Supported format: .xlsx',
        uploading: 'Uploading {filename}...',
        progress: '{percent}%',
        changeFile: 'Click to change file',
        uploadButton: 'Upload File',
        clearButton: 'Clear'
      },

      // Success/Error Messages
      messages: {
        uploadFailed: 'Upload Failed',
        tryAgain: 'Try Again',
        uploadSuccess: 'File uploaded successfully, please review before ingesting data in the system',
        fileLabel: 'File',
        recordsLabel: 'Records',
        sizeLabel: 'Size',
        invalidFileFormat: 'Please select a valid Excel file (.xlsx)',
        unknownError: 'An unknown error occurred',
        uploadFailedGeneric: 'Upload failed',
        networkError: 'Network error occurred',
        uploadFailedAlert: 'Upload failed: {message}'
      },

      // Table Columns
      columns: {
        outlet: 'Outlet',
        url: 'URL',
        headline: 'Headline',
        content: 'Content',
        publishedDate: 'Published Date',
        language: 'Language',
        status: 'Status'
      },

      // Form Labels
      form: {
        outlet: 'Outlet',
        publishedAt: 'Published At',
        language: 'Language',
        url: 'URL',
        headline: 'Headline',
        content: 'Content'
      },

      // Form Placeholders
      placeholders: {
        searchOutlet: 'Search for an outlet...',
        searchLanguage: 'Search for a language...',
        enterUrl: 'Enter URL (e.g., https://example.com/article)',
        enterHeadline: 'Enter headline',
        enterContent: 'Enter content'
      },

      // Search Results Messages
      search: {
        noOutletsFound: 'No outlets found',
        startTypingOutlets: 'Start typing to search outlets...',
        noLanguagesFound: 'No languages found',
        startTypingLanguages: 'Start typing to search languages...'
      },

      // Validation Messages
      validation: {
        outletIdNotFound: 'Outlet ID not found - action required',
        assetPathError: 'Asset path is invalid or no assets were found at the provided path',
        languageNotRecognized: 'Language not recognized - action required',
        validationError: 'Validation error',
        dateOutOfRange: 'Published date is outside 3 months range',
        rowValid: 'Row is valid'
      },

      // Actions
      actions: {
        expand: 'Expand to edit',
        collapse: 'Collapse',
        openUrl: 'Open URL in new tab',
        newUpload: 'New Upload',
        uploadArticles: 'Upload Articles',
        uploading: 'Uploading...'
      },

      // Status Messages
      status: {
        selectProject: 'Please select a project above',
        noArticles: 'No articles to upload',
        notAllArticles: '{project} - Not all articles will be uploaded as some articles have validation issues',
        readyToUpload: '{project} - Ready to upload {count} article(s)'
      },

      // File Size Units
      fileSize: {
        bytes: 'Bytes',
        kb: 'KB',
        mb: 'MB',
        gb: 'GB'
      },

      // Manage Detail Page
      detail: {
        // Header
        header: {
          title: 'Manage Manual Upload'
        },

        // Loading
        loading: {
          jobDetails: 'Loading job details...'
        },

        // Error Messages
        error: {
          failedToLoad: 'Failed to load job',
          retry: 'Retry',
          noJobId: 'No job ID provided',
          failedToRefresh: 'Failed to refresh job',
          refreshError: 'Error: {message}',
          refreshFailed: 'Failed to refresh job: {message}',
          noArticleIds: 'No valid article IDs found for the selected articles',
          syncFailed: 'Failed to sync to Insight: {message}'
        },

        // Job Info Labels
        jobInfo: {
          jobId: 'Job ID',
          projectId: 'Project ID',
          user: 'User',
          type: 'Type',
          status: 'Status',
          articles: 'Articles',
          processed: 'Processed',
          createdAt: 'Created At',
          updatedAt: 'Updated At',
          total: 'total',
          processedLabel: 'processed'
        },

        // Articles Section
        articles: {
          title: 'Articles',
          refreshStatus: 'Refresh Status',
          noArticles: 'No articles in this job',
          count: '({count})'
        },

        // Table Columns
        columns: {
          articleId: 'Article ID',
          uploadedAt: 'Uploaded At',
          seenAt: 'Seen At',
          synced: 'Synced'
        },

        // Status Values
        status: {
          skipped: 'Skipped',
          timeout: 'Timeout',
          pending: 'Pending',
          error: 'Error',
          done: 'Done',
          processing: 'Processing',
          awaitingSync: 'Awaiting',
          unknown: 'Unknown',
          errorNoDetails: 'Processing failed (no error details from backend)'
        },

        // Job Type
        jobType: {
          onlineArticles: 'Online Articles',
          printArticles: 'Print Articles'
        },

        // Values
        values: {
          unknown: 'Unknown',
          yes: 'Yes',
          no: 'No'
        },

        // Actions
        actions: {
          selectAll: 'Select all',
          syncToInsight: 'Sync to Insight',
          syncing: 'Syncing...'
        }
      },

      // Manage Page (List)
      manage: {
        // Header
        header: {
          title: 'Manage Manual Upload'
        },

        // Filter
        filter: {
          byProject: 'Filter by Project',
          allProjects: 'All projects'
        },

        // Loading
        loading: {
          jobs: 'Loading jobs...',
          moreJobs: 'Loading more jobs...'
        },

        // Error Messages
        error: {
          failedToLoad: 'Failed to load jobs',
          retry: 'Retry',
          failedToRefresh: 'Failed to refresh job',
          refreshError: 'Error: {message}',
          refreshFailed: 'Failed to refresh job: {message}'
        },

        // Empty State
        empty: {
          title: 'No upload jobs found',
          noJobsForProject: 'No jobs found for the selected project.',
          uploadToSee: 'Upload some articles to see them here.'
        },

        // Table Columns
        columns: {
          id: 'ID',
          project: 'Project',
          type: 'Type',
          articles: 'Articles',
          processed: 'Processed',
          synced: 'Synced',
          createdAt: 'Created At',
          actions: 'Actions',
          status: 'Status'
        },

        // Actions
        actions: {
          refreshJob: 'Refresh job status',
          viewDetails: 'View details'
        }
      }
    }
  }
};

module.exports.manualUploads = manualUploads;
